import { EyeIcon, EyeOffIcon } from '@langchain/untitled-ui-icons';
import { IconButton, Input } from '@mui/joy';

import { ComponentPropsWithoutRef, forwardRef, useState } from 'react';

import { cn } from '@/utils/tailwind';

export const SecretInput = forwardRef<
  HTMLInputElement,
  ComponentPropsWithoutRef<typeof Input>
>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Input
      type="text"
      sx={{
        fontFamily: "'Fira Code', monospace",
        '& input': {
          boxShadow: 'none !important',
        },
        ...(!showPassword && {
          textSecurity: 'disc',
          WebkitTextSecurity: 'disc',
          MozTextSecurity: 'disc',
        }),
      }}
      autoComplete="off"
      spellCheck="false"
      endDecorator={
        <IconButton
          aria-label="toggle password visibility"
          color="neutral"
          onClick={() => setShowPassword((show) => !show)}
          onMouseDown={(e) => e.preventDefault()}
        >
          {showPassword ? (
            <EyeOffIcon className="size-4" />
          ) : (
            <EyeIcon className="size-4" />
          )}
        </IconButton>
      }
      {...props}
      ref={ref}
    />
  );
});

export const SecretPlainInput = forwardRef<
  HTMLInputElement,
  ComponentPropsWithoutRef<'input'>
>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div
      className={cn(
        'grid grid-cols-[1fr,auto] rounded-md border border-secondary focus-within:border-brand',
        props.className
      )}
    >
      <input
        type="text"
        autoComplete="off"
        spellCheck="false"
        {...props}
        ref={ref}
        className={cn(
          'min-w-0 border-none bg-transparent px-2.5 py-2 pr-0 font-mono text-sm placeholder:text-secondary',
          !showPassword && 'text-security'
        )}
      />
      <button
        type="button"
        aria-label="toggle password visibility"
        className="p-1.5 px-2"
        onClick={() => setShowPassword((show) => !show)}
        onMouseDown={(e) => e.preventDefault()}
      >
        {showPassword ? (
          <EyeOffIcon className="size-4" />
        ) : (
          <EyeIcon className="size-4" />
        )}
      </button>
    </div>
  );
});
